import * as z from "zod/v4";

export const detectDivergentCheckoutParcelPaths = {
  name: "detectDivergentCheckoutParcelPaths" as const,

  input: z.null(),

  output: z.object({
    hasDivergentPaths: z.boolean(),
  }),
};
